import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import JsonLd from "@/components/feature/JsonLd";
import { usePageSeo } from "@/hooks/usePageSeo";
import { SITE } from "@/lib/site";
import { faqs } from "@/mocks/faqs";
import HeroSection from "./components/HeroSection";
import CategoryShowcase from "./components/CategoryShowcase";
import LatestFeed from "./components/LatestFeed";
import FeaturedPicks from "./components/FeaturedPicks";
import FaqSection from "./components/FaqSection";
import NewsletterSection from "./components/NewsletterSection";

export default function Home() {
  usePageSeo({
    title: "爆料专区 - 今日热点新鲜事 吃瓜合集每日更新",
    description: SITE.description,
    keywords: SITE.keywords,
    path: "/",
    type: "website",
  });

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE.name,
      url: SITE.domain,
      description: SITE.description,
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE.domain}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE.name,
      url: SITE.domain,
      email: SITE.email,
      description: SITE.description,
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: { "@type": "Answer", text: faq.a },
      })),
    },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <JsonLd data={jsonLd} />
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <CategoryShowcase />
        <LatestFeed />
        <FeaturedPicks />
        <FaqSection />
        <NewsletterSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}